/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
// import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import {
  Col,
  Grid,
  Row,
  Tab,
  Nav,
  NavItem,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
// import Checkbox from 'loracoms/Checkbox';
// import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import parserActions from 'loraactions/parser';
import callAPI from '@/api/callAPI';
import Debug from '../Debug';
import DebugSample from '../DebugSample';
import ScriptEditor from '../ScriptEditor';
import ScriptSample from '../ScriptSample';
import ParserData from '../ParserData';
import styles from './styles.scss';


const propTypes = {
  app: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  parser: React.PropTypes.object.isRequired,
  parserId: React.PropTypes.string.isRequired,
  getParser: React.PropTypes.func.isRequired,
};

class ParserDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      parser: props.parser,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parserdetail');
  }

  componentWillMount() {
    const { parserId, getParser } = this.props;
    getParser(parserId);
  }

  componentWillReceiveProps(nextProps) {
    const { app, parser } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
    if (parser !== this.props.parser) {
      let isConfig = false;
      let output = 'dps';
      if (parser.data) {
        const { requestconfig, outputschema } = parser.data.parser;
        isConfig = requestconfig;
        output = outputschema || 'dp';
      }
      this.setState({ parser, isConfig, output });
    }
  }

  handleChangeOutputSchema(outputschema) {
    this.setState({ output: outputschema }, () => {
      this.handleUpdateConfig({ outputschema });
    });
  }

  handleChangeConfig(requestconfig) {
    this.setState({ isConfig: requestconfig }, () => {
      this.handleUpdateConfig({ requestconfig });
    });
  }

  handleUpdateConfig(parser) {
    callAPI({
      endpoint: `/lora/parsers/${this.props.parserId}`,
      method: 'PUT',
      body: { parser },
    })
      .then(() => {}).catch(() => {});
  }

  renderToolbar() {
    const { pushState, appId } = this.props;
    const { app, parser } = this.state;
    const { data: appData = {} } = app;
    const { data: parserData = {} } = parser;

    const breadcrumb = [{
      onClick: () => pushState('/application'),
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
    }, {
      content: <Nvl val={appData.name} status={app.status} />,
      onClick: () => pushState(`/application/${appId}/parse`),
    }, {
      content: <Nvl val={parserData.name} status={parser.status} />,
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { parserId, appId } = this.props;
    // const {
      // isConfig = false,
      // output = 'dp',
      // showOption = false,
    // } = this.state;

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        {/* <div className={styles.option}>
          <div className="clearfix">
            <Link
              className="pull-right"
              onClick={() => this.setState({ showOption: !showOption })}
            >
              <i className="glyphicons glyphicons-option-vertical" />
              高级选项
            </Link>
          </div>
          <ShowIf if={showOption}>
            <div>
              <div className={styles.line}>
                <span className={styles.label}>是否需要配置：</span>
                <Checkbox
                  id="23456"
                  checked={isConfig}
                  onChange={bool => this.handleChangeConfig(bool)}
                />
              </div>
              <div className={styles.line}>
                <span className={styles.label}>数据输出类型：</span>
                <span className={styles.mgM}>
                  <Checkbox
                    id="dp"
                    checked={output === 'dp'}
                    onChange={() => this.handleChangeOutputSchema('dp')}
                  />
                  <span className={styles.mgS}>数据点</span>
                </span>
                <span>
                  <Checkbox
                    id="stream"
                    checked={output === 'stream'}
                    onChange={() => this.handleChangeOutputSchema('stream')}
                  />
                  <span className={styles.mgS}>数据流</span>
                </span>
              </div>
            </div>
          </ShowIf>
        </div> */}
        <Row>
          <Col md={7}>
            <ScriptEditor parserId={parserId} />
          </Col>
          <Col md={5} className="collapse-left">
            <Tab.Container id="helpTabs" defaultActiveKey="sample">
              <Row className="clearfix">
                <Col sm={12}>
                  <Nav bsStyle="aisz-tabs">
                    <NavItem eventKey="sample">
                      {this.intlMsg.msg('helptabs.sample')}
                    </NavItem>
                    <NavItem eventKey="debug">
                      debug
                    </NavItem>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content animation>
                    <Tab.Pane eventKey="sample">
                      <div className={styles.tab}>
                        <ScriptSample />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="debug">
                      <div className={styles.tabBase}>
                        <DebugSample />
                        <Debug />
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={styles.data}>
              <ParserData appId={appId} parserId={parserId} />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

ParserDetail.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  parserId: ownProps.params.parserId,
  app: state.app.getApp,
  parser: state.parser.getParser,
});
const mapDispatchToProps = {
  pushState: routerActions.push,
  getParser: parserActions.getParser,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ParserDetail));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserDetail/index.jsx